import { render, staticRenderFns } from "./LegalDocumentDetailsBox.vue?vue&type=template&id=a030792a&scoped=true&"
import script from "./LegalDocumentDetailsBox.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentDetailsBox.vue?vue&type=script&lang=js&"
import style0 from "./LegalDocumentDetailsBox.vue?vue&type=style&index=0&id=a030792a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a030792a",
  null
  
)

export default component.exports